import React from "react";
import styled from "styled-components";
import { IconButton } from "@origin-digital/style-guide";
import { ClearIcon } from "@origin-digital/icon";
import { sendInteractionEvent } from "../NextBestAction.utils";
export var FloatingIconContainer = styled.div.withConfig({
  displayName: "Dismiss__FloatingIconContainer",
  componentId: "sc-1b1cdx6-0"
})(["position:absolute;right:16px;top:14px;@media only screen and (max-width:767px){right:0px;top:10px;}"]);
export var getDismissId = function getDismissId(dismissDuration) {
  return dismissDuration ? "dismiss-".concat(dismissDuration, "d") : "dismiss";
};
export var Dismiss = function Dismiss(_ref) {
  var content = _ref.content,
      context = _ref.context,
      cardName = _ref.cardName,
      onHide = _ref.onHide;
  return content.isDismissable ? React.createElement(FloatingIconContainer, {
    onClickCapture: sendInteractionEvent(getDismissId(content.dismissDuration), content.experienceId, context, cardName)
  }, React.createElement(IconButton, {
    "data-id": "dismiss",
    icon: ClearIcon,
    onClick: onHide,
    color: "red",
    trackingDisabled: true
  })) : null;
};